import { render, staticRenderFns } from "./Garantias_Aseguradora.vue?vue&type=template&id=32564f40&scoped=true&"
import script from "./Garantias_Aseguradora.vue?vue&type=script&lang=js&"
export * from "./Garantias_Aseguradora.vue?vue&type=script&lang=js&"
import style0 from "./Garantias_Aseguradora.vue?vue&type=style&index=0&id=32564f40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32564f40",
  null
  
)

export default component.exports